var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"activity-list"},_vm._l((_vm.activities),function(activity){return _c('div',{key:activity.id,staticClass:"mb-1"},[_vm._v(" "+_vm._s(activity.name)+" "),_c('ShowActivitiesWidget',{attrs:{"activity":activity}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }